import React from "react";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import dayjs from "dayjs";

const Footer: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();

  return (
    <footer className="mx-4 mb-4 rounded-2xl bg-black px-6 py-4 sm:mx-6 sm:h-27 sm:p-10">
      <div className="mx-auto sm:w-[1000px]">
        <div className="grid grid-cols-2 text-[15px] sm:gap-6">
          <div className="col-span-2 leading-loose sm:col-span-1">
            {tCommon("footer_text", { year: dayjs().year() })}
          </div>
          <div className="col-span-2 leading-loose sm:col-span-1 sm:flex sm:justify-end">
            <div>
              <a
                href="https://mwork365.com/vop"
                target="_blank"
                className="underline"
              >
                Všeobecné obchodní podminky
              </a>
              <span className="mx-1">•</span>
            </div>
            <div>
              <a
                href="https://mwork365.com/soukromi"
                target="_blank"
                className="underline"
              >
                Pravidla ochrany soukromí
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
